import { render } from "./BannerSlider.vue?vue&type=template&id=05340f04&scoped=true"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"

import "./BannerSlider.vue?vue&type=style&index=0&id=05340f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05340f04"]])

export default __exports__